const GooglePlayIcon = ({ onClick }: { onClick: () => void }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="205"
            height="59"
            viewBox="0 0 205 59"
            fill="none"
            onClick={onClick}
        >
            <path
                d="M196.537 59H7.69409C3.54144 59 0.140381 55.6794 0.140381 51.625V7.375C0.140381 3.32059 3.54144 7.56029e-07 7.69409 7.56029e-07H196.537C200.689 7.56029e-07 204.09 3.32059 204.09 7.375V51.625C204.09 55.6794 200.689 59 196.537 59Z"
                fill="black"
            />
            <path
                d="M196.537 1.18184C200.034 1.18184 202.88 3.96037 202.88 7.375V51.625C202.88 55.0396 200.034 57.8182 196.537 57.8182H7.69409C4.19672 57.8182 1.35086 55.0396 1.35086 51.625V7.375C1.35086 3.96037 4.19672 1.18184 7.69409 1.18184H196.537ZM196.537 7.56029e-07H7.69409C3.54144 7.56029e-07 0.140381 3.32059 0.140381 7.375V51.625C0.140381 55.6794 3.54144 59 7.69409 59H196.537C200.689 59 204.09 55.6794 204.09 51.625V7.375C204.09 3.32059 200.689 7.56029e-07 196.537 7.56029e-07Z"
                fill="#A6A6A6"
            />
            <path
                d="M71.7759 15.1095C71.7759 16.3411 71.3982 17.3275 70.6542 18.0632C69.7987 18.9353 68.6846 19.3741 67.3192 19.3741C66.0143 19.3741 64.9002 18.9279 63.9862 18.0484C63.0703 17.1561 62.6133 16.0609 62.6133 14.75C62.6133 13.4391 63.0703 12.3439 63.9862 11.4589C64.9002 10.572 66.0143 10.1259 67.3192 10.1259C67.9689 10.1259 68.5883 10.2568 69.1793 10.5001C69.7685 10.7454 70.2482 11.0772 70.5957 11.4865L69.8063 12.2646C69.2001 11.5658 68.3749 11.221 67.3192 11.221C66.3675 11.221 65.5422 11.5455 64.8416 12.2001C64.1486 12.8564 63.8011 13.7064 63.8011 14.75C63.8011 15.7935 64.1486 16.6509 64.8416 17.3073C65.5422 17.9544 66.3675 18.2863 67.3192 18.2863C68.3296 18.2863 69.1793 17.9544 69.8497 17.2999C70.2916 16.8666 70.5428 16.2692 70.6089 15.5059H67.3192V14.4402H71.7079C71.7608 14.6707 71.7759 14.8938 71.7759 15.1095Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M78.7387 11.4146H74.6163V14.2171H78.3327V15.2828H74.6163V18.0853H78.7387V19.1712H73.4492V10.3286H78.7387V11.4146Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M83.6522 19.1712H82.4851V11.4146H79.9565V10.3286H86.1827V11.4146H83.6522V19.1712Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M90.6885 19.1712V10.3286H91.8536V19.1712H90.6885Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M97.0184 19.1712H95.8608V11.4146H93.3228V10.3286H99.5564V11.4146H97.0184V19.1712Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M111.344 18.0337C110.451 18.9279 109.344 19.3741 108.024 19.3741C106.697 19.3741 105.59 18.9279 104.697 18.0337C103.806 17.1413 103.362 16.0461 103.362 14.75C103.362 13.4538 103.806 12.3586 104.697 11.4663C105.59 10.572 106.697 10.1259 108.024 10.1259C109.337 10.1259 110.443 10.572 111.337 11.4736C112.236 12.3734 112.679 13.4612 112.679 14.75C112.679 16.0461 112.236 17.1413 111.344 18.0337ZM105.56 17.2925C106.232 17.9544 107.05 18.2863 108.024 18.2863C108.991 18.2863 109.816 17.9544 110.481 17.2925C111.152 16.6306 111.491 15.7806 111.491 14.75C111.491 13.7193 111.152 12.8694 110.481 12.2074C109.816 11.5455 108.991 11.2137 108.024 11.2137C107.05 11.2137 106.232 11.5455 105.56 12.2074C104.89 12.8694 104.55 13.7193 104.55 14.75C104.55 15.7806 104.89 16.6306 105.56 17.2925Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M114.316 19.1712V10.3286H115.733L120.137 17.2058H120.188L120.137 15.5059V10.3286H121.302V19.1712H120.086L115.474 11.9548H115.423L115.474 13.6621V19.1712H114.316Z"
                fill="white"
                stroke="white"
                strokeWidth="0.16"
                strokeMiterlimit="10"
            />
            <path
                d="M103.075 32.0849C99.5263 32.0849 96.6275 34.7215 96.6275 38.3592C96.6275 41.9674 99.5263 44.6316 103.075 44.6316C106.631 44.6316 109.529 41.9674 109.529 38.3592C109.529 34.7215 106.631 32.0849 103.075 32.0849ZM103.075 42.161C101.128 42.161 99.4526 40.592 99.4526 38.3592C99.4526 36.0969 101.128 34.5555 103.075 34.5555C105.022 34.5555 106.704 36.0969 106.704 38.3592C106.704 40.592 105.022 42.161 103.075 42.161ZM89.0077 32.0849C85.4518 32.0849 82.5607 34.7215 82.5607 38.3592C82.5607 41.9674 85.4518 44.6316 89.0077 44.6316C92.5618 44.6316 95.4548 41.9674 95.4548 38.3592C95.4548 34.7215 92.5618 32.0849 89.0077 32.0849ZM89.0077 42.161C87.0589 42.161 85.3782 40.592 85.3782 38.3592C85.3782 36.0969 87.0589 34.5555 89.0077 34.5555C90.9547 34.5555 92.6297 36.0969 92.6297 38.3592C92.6297 40.592 90.9547 42.161 89.0077 42.161ZM72.2687 34.0079V36.674H78.7895C78.5987 38.1638 78.0889 39.2589 77.3071 40.0223C76.3553 40.9441 74.8729 41.9674 72.2687 41.9674C68.2558 41.9674 65.1135 38.8054 65.1135 34.8874C65.1135 30.9694 68.2558 27.8074 72.2687 27.8074C74.4385 27.8074 76.0173 28.6353 77.1824 29.7083L79.1067 27.8295C77.477 26.3103 75.3091 25.1432 72.2687 25.1432C66.7659 25.1432 62.1411 29.5147 62.1411 34.8874C62.1411 40.2601 66.7659 44.6316 72.2687 44.6316C75.243 44.6316 77.477 43.6803 79.2333 41.8955C81.0329 40.1384 81.5938 37.6678 81.5938 35.6728C81.5938 35.0533 81.5409 34.4836 81.4465 34.0079H72.2687ZM140.717 36.0748C140.186 34.6717 138.549 32.0849 135.214 32.0849C131.909 32.0849 129.158 34.6274 129.158 38.3592C129.158 41.8734 131.881 44.6316 135.531 44.6316C138.483 44.6316 140.186 42.8745 140.887 41.8513L138.696 40.426C137.965 41.4696 136.97 42.161 135.531 42.161C134.101 42.161 133.076 41.5212 132.419 40.2601L141.013 36.7883L140.717 36.0748ZM131.954 38.1638C131.881 35.7448 133.879 34.5058 135.31 34.5058C136.432 34.5058 137.384 35.0533 137.701 35.8369L131.954 38.1638ZM124.969 44.25H127.794V25.8125H124.969V44.25ZM120.342 33.4825H120.248C119.613 32.7487 118.403 32.0849 116.87 32.0849C113.652 32.0849 110.71 34.8432 110.71 38.3795C110.71 41.8955 113.652 44.6316 116.87 44.6316C118.403 44.6316 119.613 43.9623 120.248 43.2064H120.342V44.1062C120.342 46.5049 119.03 47.7937 116.913 47.7937C115.187 47.7937 114.116 46.5768 113.674 45.5535L111.218 46.5547C111.926 48.2177 113.801 50.2643 116.913 50.2643C120.225 50.2643 123.02 48.3615 123.02 43.7319V32.4666H120.342V33.4825ZM117.111 42.161C115.164 42.161 113.535 40.5698 113.535 38.3795C113.535 36.1688 115.164 34.5555 117.111 34.5555C119.03 34.5555 120.543 36.1688 120.543 38.3795C120.543 40.5698 119.03 42.161 117.111 42.161ZM153.943 25.8125H147.186V44.25H150.004V37.264H153.943C157.072 37.264 160.141 35.0533 160.141 31.5373C160.141 28.0231 157.065 25.8125 153.943 25.8125ZM154.017 34.6993H150.004V28.3771H154.017C156.121 28.3771 157.322 30.0826 157.322 31.5373C157.322 32.9644 156.121 34.6993 154.017 34.6993ZM171.434 32.0499C169.398 32.0499 167.281 32.9275 166.411 34.8727L168.911 35.8959C169.449 34.8727 170.439 34.5408 171.485 34.5408C172.946 34.5408 174.429 35.3981 174.451 36.9118V37.1054C173.942 36.8178 172.85 36.3919 171.507 36.3919C168.815 36.3919 166.071 37.8393 166.071 40.5403C166.071 43.011 168.276 44.6021 170.756 44.6021C172.652 44.6021 173.698 43.7669 174.355 42.7953H174.451V44.2205H177.173V37.1478C177.173 33.8789 174.672 32.0499 171.434 32.0499ZM171.094 42.1536C170.172 42.1536 168.888 41.7074 168.888 40.592C168.888 39.1649 170.49 38.6173 171.876 38.6173C173.116 38.6173 173.698 38.8847 174.451 39.2368C174.231 40.9441 172.725 42.1536 171.094 42.1536ZM187.087 32.4537L183.848 40.4463H183.752L180.404 32.4537H177.365L182.396 43.6231L179.526 49.8384H182.47L190.222 32.4537H187.087ZM161.689 44.25H164.515V25.8125H161.689V44.25Z"
                fill="white"
            />
            <path
                d="M15.905 11.1197C15.4612 11.5732 15.2043 12.2794 15.2043 13.1939V45.8135C15.2043 46.728 15.4612 47.4342 15.905 47.8877L16.0145 47.9873L34.7363 29.7157V29.2843L16.0145 11.0127L15.905 11.1197Z"
                fill="url(#paint0_linear_5692_20339)"
            />
            <path
                d="M40.97 35.8093L34.7363 29.7157V29.2843L40.9776 23.1907L41.1173 23.27L48.5086 27.376C50.618 28.5413 50.618 30.4588 48.5086 31.6314L41.1173 35.73L40.97 35.8093Z"
                fill="url(#paint1_linear_5692_20339)"
            />
            <path
                d="M41.1174 35.73L34.7364 29.5L15.905 47.8877C16.6056 48.6068 17.7481 48.6934 19.0474 47.9744L41.1174 35.73Z"
                fill="url(#paint2_linear_5692_20339)"
            />
            <path
                d="M41.1174 23.27L19.0474 11.0256C17.7481 10.3139 16.6056 10.4006 15.905 11.1197L34.7364 29.5L41.1174 23.27Z"
                fill="url(#paint3_linear_5692_20339)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_5692_20339"
                    x1="33.0741"
                    y1="46.1532"
                    x2="8.32711"
                    y2="20.8066"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00A0FF" />
                    <stop offset="0.0066" stopColor="#00A1FF" />
                    <stop offset="0.2601" stopColor="#00BEFF" />
                    <stop offset="0.5122" stopColor="#00D2FF" />
                    <stop offset="0.7604" stopColor="#00DFFF" />
                    <stop offset="1" stopColor="#00E3FF" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_5692_20339"
                    x1="51.2554"
                    y1="29.4979"
                    x2="14.7001"
                    y2="29.4979"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FFE000" />
                    <stop offset="0.4087" stopColor="#FFBD00" />
                    <stop offset="0.7754" stopColor="#FFA500" />
                    <stop offset="1" stopColor="#FF9C00" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_5692_20339"
                    x1="37.6476"
                    y1="26.1132"
                    x2="4.08874"
                    y2="-8.2588"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF3A44" />
                    <stop offset="1" stopColor="#C31162" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_5692_20339"
                    x1="11.1648"
                    y1="58.7401"
                    x2="26.1503"
                    y2="43.3916"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32A071" />
                    <stop offset="0.0685" stopColor="#2DA771" />
                    <stop offset="0.4762" stopColor="#15CF74" />
                    <stop offset="0.8009" stopColor="#06E775" />
                    <stop offset="1" stopColor="#00F076" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default GooglePlayIcon;
